import { useRemoteClientPost } from '@/configs/http-client';
import { Endpoints } from '@/remote/endpoints';
import { useLocalStorage } from '@/remote/local-storage';
import { PaginationDemo } from '@/view/components/pagination';
import { TableUser } from '@/view/components/table-users';
import { usePagination } from '@/view/hooks';
import { usePromiseToast } from '@/view/hooks/toast-promisse';
import { UsersFormData } from '@/view/validators/users-validator';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function DisplayUser() {

  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [data, setData] = useState<UsersFormData[]>([])
  const [params] = useSearchParams()
  const [controlPage, setControlPage] = useState(0)

  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0
  })
  const quantityForPage = 10

  const getNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, setControlPage);
    setPageInfo((prev) => ({ ...prev, page: controlPage }));
  };

  const getBackPage = () => {
    backPage(pageInfo.page, setControlPage);
    setPageInfo((prev) => ({ ...prev, page: controlPage }));
  };

  const fetchData = async () => {
    try {
      const response = await httpClientPost(`${Endpoints.users}/filtro?page=${controlPage}&size=${quantityForPage}&order=desc&sort=id`, {
        idUnidade: [params.get('id') ?? getUnitId()],
        status: 1,
        perfis: [1,3,4,5,6,7,8,9,10],
      });

      const data = response?.data?.data ?? {};
      const content = data?.content ?? [];
      const page = data?.pageable?.pageNumber ?? 0;
      const totalPages = data?.totalPages;
      const total = data?.totalElements;
      //console.log(page, totalPages, total)

      setData(content);
      setPageInfo({
        page: page,
        total: total,
        totalPages: totalPages
      })

    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };


  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  useEffect(() => {
    handleRefresh()
  }, [controlPage, params]);

  return (
    <>
      <TableUser data={data} height='h-96' getRefreshList={handleRefresh} />
      <PaginationDemo
        totalForPage={quantityForPage}
        back={getBackPage}
        next={getNextPage}
        page={pageInfo.page}
        total={pageInfo.total}
        labelItem='Usuários'
      />
    </>
  )
}